const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

export const fetchData = async (url) => {
    const response = await fetch(url);
    if (!response.ok) {
        const errorText = await response.text(); // Tenta ler como texto para depuração
        throw new Error(`HTTP error! status: ${response.status}, details: ${errorText}`);
    }
    return response.json();
};

export const getRaceDetails = (id) => fetchData(`${API_URL}/races/${id}/`);
export const getChampionships = () => fetchData(`${API_URL}/championships/`);
export const getChampionshipDetails = (id) => fetchData(`${API_URL}/championships/${id}`);
export const getTeamDetails = (id) => fetchData(`${API_URL}/teams/${id}`);
export const getLeagueDetails = (id) => fetchData(`${API_URL}/leagues/${id}/`);

export const startLeagueRegisterOAuth = (leagueId) =>
    fetchData(`${API_URL}/leagues/register-oauth-start/?league_id=${leagueId}`);

export const createManualChampionship = (leagueId, data) =>
    fetch(`${API_URL}/leagues/${leagueId}/create-championship/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const startManualLeagueOAuth = () =>
    fetchData(`${API_URL}/leagues/manual-oauth-start/`);

export const registerManualLeague = (formData) =>
    fetch(`${API_URL}/leagues/register-manual/`, {
        method: 'POST',
        body: formData,
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const registerLeague = (data) =>
    fetch(`${API_URL}/leagues/register/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const verifyLeaguePassword = (leagueId, password) =>
    fetch(`${API_URL}/leagues/${leagueId}/verify-password/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const updateSession = (subsessionId, password, data) =>
    fetch(`${API_URL}/races/${subsessionId}/organizer-update/`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password, ...data }),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const getTodayRaces = () => fetchData(`${API_URL}/races/today/`);

export const getSessionLiveInfo = (leagueSessionId) =>
    fetchData(`${API_URL}/sessions/${leagueSessionId}/live/`);

export const getChampionshipStandings = (championshipId) =>
    fetchData(`${API_URL}/championships/${championshipId}/standings/`);

export const getChampionshipPointsConfig = (championshipId) =>
    fetchData(`${API_URL}/championships/${championshipId}/points-config/`);

export const getSeriesList = () =>
    fetchData(`${API_URL}/series/`);

export const updateChampionshipSeries = (championshipId, seriesName, password) =>
    fetch(`${API_URL}/championships/${championshipId}/points-config/`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ series_name: seriesName, password }),
    }).then(r => r.json());

export const updatePointsConfig = (championshipId, password, data) =>
    fetch(`${API_URL}/championships/${championshipId}/points-config/`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password, ...data }),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const getSeriesDetail = (leagueId, seriesId) =>
    fetchData(`${API_URL}/leagues/${leagueId}/series/${seriesId}/`);

export const startLeagueOAuthClaim = (leagueId) =>
    fetchData(`${API_URL}/leagues/${leagueId}/oauth-start/`);

export const claimLeaguePassword = (leagueId, claimToken, password) =>
    fetch(`${API_URL}/leagues/${leagueId}/claim-password/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ claim_token: claimToken, password }),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const updatePreRace = (leagueSessionId, password, broadcastUrl, itelemetryUrl) =>
    fetch(`${API_URL}/sessions/${leagueSessionId}/pre-race/`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password, broadcast_url: broadcastUrl, itelemetry_url: itelemetryUrl }),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const getTwitchStreams = (tab) => fetchData(`${API_URL}/twitch/streams/?tab=${tab}`);

export const getUpcomingRaces = () => fetchData(`${API_URL}/races/upcoming/`);
export const getRecentRaces = () => fetchData(`${API_URL}/races/recent/`);

export const getMonthRaces = (year, month) =>
  fetchData(`${API_URL}/races/by-month/?year=${year}&month=${month}`);

export const getArticles = (page = 1, source = null) => {
    const params = new URLSearchParams({ page });
    if (source) params.set('source', source);
    return fetchData(`${API_URL}/articles/?${params}`);
};

export const startProtestOAuth = (subsessionId) =>
    fetchData(`${API_URL}/races/${subsessionId}/protest-oauth-start/`);

export const submitProtest = (subsessionId, protestToken, description, attachment) => {
    const form = new FormData();
    form.append('protest_token', protestToken);
    form.append('description', description);
    if (attachment) form.append('attachment', attachment);
    return fetch(`${API_URL}/races/${subsessionId}/protest/`, {
        method: 'POST',
        body: form,
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));
};

export const getRaceProtests = (subsessionId, password) =>
    fetchData(`${API_URL}/races/${subsessionId}/protests/?password=${encodeURIComponent(password)}`);

export const startMarketplaceOAuth = () =>
    fetchData(`${API_URL}/marketplace/oauth-start/`);

export const createMarketplacePayment = (marketplaceToken, provider = 'mercadopago') =>
    fetch(`${API_URL}/marketplace/create-payment/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ marketplace_token: marketplaceToken, provider }),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

// verifyParam: raw query string, e.g. "payment_id=123" or "session_id=cs_xxx"
export const verifyMarketplacePayment = (verifyParam) =>
    fetchData(`${API_URL}/marketplace/verify-payment/?${verifyParam}`);

export const getMarketplaceListings = (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return fetchData(`${API_URL}/marketplace/${qs ? '?' + qs : ''}`);
};

export const getMarketplaceListing = (id) =>
    fetchData(`${API_URL}/marketplace/${id}/`);

export const createMarketplaceListing = (formData) =>
    fetch(`${API_URL}/marketplace/`, { method: 'POST', body: formData })
        .then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const startMarketplaceDeleteOAuth = (id) =>
    fetchData(`${API_URL}/marketplace/${id}/delete-oauth-start/`);

// Widget subscription
export const getWidgetSubscriptionStatus = (leagueId, password) =>
    fetchData(`${API_URL}/leagues/${leagueId}/widget-subscription/?password=${encodeURIComponent(password)}`);

export const startWidgetSubscription = (leagueId, password, planMonths, provider) =>
    fetch(`${API_URL}/leagues/${leagueId}/widget-subscription/start/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password, plan_months: planMonths, provider }),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

// verifyParam: e.g. "payment_id=123" or "session_id=cs_xxx"
export const verifyWidgetSubscription = (leagueId, verifyParam) =>
    fetchData(`${API_URL}/leagues/${leagueId}/widget-subscription/verify/?${verifyParam}`);

export const saveWidgetWebhook = (leagueId, password, discordWebhookUrl) =>
    fetch(`${API_URL}/leagues/${leagueId}/widget-subscription/webhook/`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password, discord_webhook_url: discordWebhookUrl }),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const getWidgetChampionshipData = (widgetToken, champId) =>
    fetchData(`${API_URL}/widget/${widgetToken}/championships/${champId}/`);

export const getWidgetRaceData = (widgetToken, champId, subsessionId) =>
    fetchData(`${API_URL}/widget/${widgetToken}/championships/${champId}/races/${subsessionId}/`);

export const completeScheduledRace = (leagueSessionId, subsessionId, password) =>
    fetch(`${API_URL}/sessions/${leagueSessionId}/complete/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subsession_id: subsessionId, password }),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const addScheduledRace = (championshipId, data) =>
    fetch(`${API_URL}/championships/${championshipId}/add-scheduled-race/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const importRaceBySubsession = (championshipId, subsessionId, password) =>
    fetch(`${API_URL}/championships/${championshipId}/import-race/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subsession_id: subsessionId, password }),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));

export const markMarketplaceSold = (id, custId, marketplaceToken) =>
    fetch(`${API_URL}/marketplace/${id}/mark-sold/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cust_id: custId, marketplace_token: marketplaceToken }),
    }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));
